import React from 'react'
import Layout from '../components/Layout'
import RichText from '../components/RichText'

function Section({ title, style, content, isFirst }) {
  const isDark = style === 'dark'
  const bgClass = isDark ? 'bg-brand-dark text-white' : 'bg-brand-bg text-brand-dark'

  return (
    <div className={`${bgClass} py-8`}>
      <div className="container mx-auto px-4">
        {isFirst ? (
          <div className="flex items-center mb-6">
            <h2 className="text-brand-light font-bold uppercase text-xl font-heading">{title}</h2>
            <hr className="flex-1 ml-4 border-0 h-[1px] bg-brand-light" />
          </div>
        ) : (
          <h3 className="text-2xl font-bold mb-6 font-heading">{title}</h3>
        )}

        <RichText content={content} className="text-justify" invert={isDark} columns />
      </div>
    </div>
  )
}

export default function Metodologia({ sections = [], methodologyImage }) {
  return (
    <Layout fullWidth>
      {sections.map((section, index) => (
        <Section
          key={index}
          title={section.title}
          style={section.style}
          content={section.content}
          isFirst={index === 0}
        />
      ))}

      <div className="bg-brand-bg py-8">
        <div className="container mx-auto px-4 text-center">
          <img
            src={methodologyImage}
            alt="Metodologia Final"
            className="w-3/4 mx-auto rounded"
          />
        </div>
      </div>
    </Layout>
  )
}
